import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { CheckCircle2, TrendingUp, Shield, Zap } from 'lucide-react';
import MyButton from '../../../components/common/Button/MyButton';
import '../../../assets/styles/customer/layout/HeroSection.css'; 
import { useNavigate } from 'react-router-dom';

// ... baaki sab same rehne do


// import React, { useEffect, useState } from 'react';
// import { Container, Row, Col } from 'react-bootstrap';
// import { CheckCircle2, TrendingUp, Shield, Zap } from 'lucide-react';
// import MyButton from '../../../components/common/Button/MyButton';
// import '../../../assets/styles/customer/HeroSection.css';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="milkyway-hero-section">
      
      {/* Animated Background Waves */}
      <div className="hero-bg-waves">
        <svg className="wave wave-1" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path fill="rgba(62, 150, 231, 0.08)" d="M0,160L48,176C96,192,192,224,288,213.3C384,203,480,149,576,133.3C672,117,768,139,864,154.7C960,171,1056,181,1152,176C1248,171,1344,149,1392,138.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
        <svg className="wave wave-2" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path fill="rgba(76, 175, 80, 0.05)" d="M0,96L48,112C96,128,192,160,288,165.3C384,171,480,149,576,128C672,107,768,85,864,90.7C960,96,1056,128,1152,138.7C1248,149,1344,139,1392,133.3L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>

      {/* Floating Elements */}
      <div className="floating-decorations">
        <div className="float-element element-1">
          <CheckCircle2 size={32} strokeWidth={1.5} />
        </div>
        <div className="float-element element-2">
          <TrendingUp size={28} strokeWidth={1.5} />
        </div>
        <div className="float-element element-3">
          <Shield size={30} strokeWidth={1.5} />
        </div>
        <div className="float-element element-4">
          <Zap size={26} strokeWidth={1.5} />
        </div>
      </div>

      <Container className="hero-container">
        <Row className="align-items-center h-100">
          
          {/* Left Content */}
          <Col lg={6} md={12} className="hero-content-col">
            <div className={`hero-text-content ${isVisible ? 'animate-in' : ''}`}>
              
              {/* Main Heading */}
              <h1 className="hero-main-heading">
                MilkyWay
              </h1>

              {/* Subtitle */}
              <h2 className="hero-subtitle">
                Smart Milk Distribution & Billing System
              </h2>

              {/* Description */}
              <p className="hero-description">
                QR-based daily milk tracking with automated monthly billing
              </p>

              {/* CTA Buttons */}
              <div className="hero-action-buttons">
                <MyButton variant="primary" className="view-btn" onClick={()=>navigate('/distributor-signup')}>
                  Become a Distributor
                </MyButton>
                {/* <MyButton variant="primary" className="view-btn">
                  Supplier Login
                </MyButton> */}
              </div>

              {/* Feature Tags */}
              <div className="hero-feature-tags">
                <div className="feature-tag">
                  <CheckCircle2 size={16} />
                  <span>QR Code Tracking</span>
                </div>
                <div className="feature-tag">
                  <CheckCircle2 size={16} />
                  <span>Auto Billing</span>
                </div>
                <div className="feature-tag">
                  <CheckCircle2 size={16} />
                  <span>Real-time Updates</span>
                </div>
              </div>

            </div>
          </Col>

          {/* Right Illustration */}
          <Col lg={6} md={12} className="hero-illustration-col">
            <div className={`hero-illustration-wrapper ${isVisible ? 'animate-in' : ''}`}>
              
              {/* Illustration Container */}
              <div className="illustration-scene">
                
                {/* Main Character - Delivery Person */}
                <div className="delivery-person">
                  <div className="person-container">
                    <div className="person-head">
                      <div className="cap"></div>
                      <div className="face">
                        <div className="eyes">
                          <div className="eye"></div>
                          <div className="eye"></div>
                        </div>
                        <div className="smile"></div>
                      </div>
                    </div>
                    <div className="person-body">
                      <div className="uniform"></div>
                      <div className="arm-left"></div>
                      <div className="arm-right">
                        <div className="phone">
                          <CheckCircle2 size={12} color="#4caf50" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Milk Container with QR */}
                <div className="milk-container-scene">
                  <div className="big-container">
                    <div className="container-top"></div>
                    <div className="container-body">
                      <div className="qr-code">
                        <div className="qr-pattern"></div>
                      </div>
                    </div>
                    <div className="container-handle-left"></div>
                    <div className="container-handle-right"></div>
                  </div>
                </div>

                {/* Milk Bottles */}
                <div className="milk-bottles-group">
                  <div className="bottle bottle-1">
                    <div className="bottle-cap"></div>
                    <div className="bottle-body"></div>
                  </div>
                  <div className="bottle bottle-2">
                    <div className="bottle-cap"></div>
                    <div className="bottle-body"></div>
                  </div>
                  <div className="bottle bottle-3">
                    <div className="bottle-cap"></div>
                    <div className="bottle-body"></div>
                  </div>
                </div>

                {/* Delivery Truck */}
                <div className="delivery-truck">
                  <div className="truck-container">
                    <div className="truck-cabin"></div>
                    <div className="truck-back">
                      <div className="milk-icon-truck">🥛</div>
                    </div>
                    <div className="truck-wheel wheel-front"></div>
                    <div className="truck-wheel wheel-back"></div>
                  </div>
                </div>

                {/* Success Checkmark Badge */}
                <div className="success-badge floating-badge">
                  <CheckCircle2 size={24} color="#4caf50" strokeWidth={2.5} />
                </div>

              </div>

            </div>
          </Col>

        </Row>
      </Container>

    </section>
  );
};

export default HeroSection;